// extracted by mini-css-extract-plugin
export default {"button":"SecondaryButton_button__z1b8k","loadingIcon":"SecondaryButton_loadingIcon__zbJme","showLoading":"SecondaryButton_showLoading__Vwnlc"};